/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { HomeAgendaAttendee } from './HomeAgendaAttendee';
import type { HomeMeetingDoc } from './HomeMeetingDoc';

export type HomeAgendaItem = {
    id: string;
    title: string;
    start: number;
    end: number;
    all_day?: boolean;
    source?: HomeAgendaItem.source;
    location?: (string | null);
    join_url?: (string | null);
    attendee_count?: (number | null);
    attendees?: Array<HomeAgendaAttendee>;
    description?: (string | null);
    docs?: Array<HomeMeetingDoc>;
    calendar_url?: (string | null);
};

export namespace HomeAgendaItem {

    export enum source {
        PERSONAL = 'personal',
        COMPANY = 'company',
    }


}

